import React, { useEffect, useState } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";

import Modal from "react-bootstrap/Modal";
import { Input } from "rsuite";
import { Checkbox } from "@chakra-ui/react";
import Spinner from "react-bootstrap/Spinner";

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import { useToast } from '@chakra-ui/react'


import { useSelector, useDispatch } from "react-redux";
import { getCaompanyAllAction } from "../../../../../redux/reducer/getAllCompanyForAdmin/action/action";
import "./modalEditCompany.css";
import BlockCompany from "../blockCompany/blockCompany";
export default function ModalEdit({ shows, setShows, data,currentPage,index }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShows(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false);
  const getCompany = useSelector((company) => company);
  const dispatch = useDispatch();
  const toast = useToast()
  useEffect(() => {
    setShow(shows);
  }, [shows, setShows]);

  const editCompantByAdmin = (e) => {
    e.preventDefault();
      
    setLoading(true)
    axios
      .patch("/copany/edit/byAdminPanel", {
        data: {
          inn: e.target.inn.value,
          sellersname: e.target.sellersname.value,
          indirecttax: e.target.indirecttax.checked,
          Legaladdress: e.target.Legaladdress.value,
          Checkingaccount: e.target.Checkingaccount.value,
          btc: e.target.btc.value,
          ognip: e.target.ognip.value,
          companyID: data._id,
          walberisToken: e.target.walberisToken.value,
          walberisToken2: e.target.walberisToken2.value,
          walberisToken3: e.target.walberisToken3.value,
          ozonToken1: e.target.ozonToken1.value,
          ozonToken2: e.target.ozonToken2.value,
          BlockCompanys: e.target.blockCompany.checked,
        },
      })
      .then((rezult) => {
        dispatch(getCaompanyAllAction(`/getAllCompant/admin/api?page=${currentPage}`))
        setLoading(false)
        setShows(false)
      }).catch(error=>{
        console.log(error,"asdasd");
        setLoading(false)
        toast({
          position:"top",
          title: 'Account created.',
          description:error.response.data.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      })
  };

  return (
    <>
      <Modal show={shows} onHide={handleClose} fullscreen={true}>
        <Modal.Header closeButton>
          <Modal.Title style={{ marginLeft: "5%" }}>
            НАЗВАНИЕ КОМПАНИИ: {data.sellersname}
            
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          <div className="adminSettingsCont">
            <p>Добавление компании</p>
            <form onSubmit={editCompantByAdmin}>
              <div className="formchildCont1">
                <label htmlFor="">ИНН</label>
                <Input
                  placeholder="ИНН"
                  name="inn"
                  defaultValue={data.inn}
                  key={data.inn + "1"}
                />
                <label htmlFor="">Наименование продавца</label>
                <Input
                  placeholder="наименование продавца"
                  name="sellersname"
                  defaultValue={data.sellersname}
                  key={data.sellersname + "2"}
                />
                <div className="chekcbox" color="#5E80E4">
                  {" "}
                  <Checkbox
                    name="indirecttax"
                    defaultChecked={data.indirecttax}
                  >
                    С НДС
                  </Checkbox>
                </div>
                <label htmlFor="">Юридический адрес</label>
                <Input
                  as="textarea"
                  rows={4}
                  placeholder="Юридический адрес"
                  name="Legaladdress"
                  defaultValue={data.Legaladdress}
                  key={data.Legaladdress + "3"}
                />

                <div className="apis">
                  {/* api inputs ============================================================================== */}
                  <Accordion allowMultiple>
                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box as="span" flex="1" textAlign="left">
                            Wb API
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4} className="wbCont"  >
                        <label htmlFor="">Общий</label>
                        <Input
                          placeholder="Общий"
                          name="walberisToken"
                          defaultValue={data.walberisToken}
                          key={data.walberisToken + "4"}
                        />
                        
                        <label htmlFor="">Статистика</label>
                        <Input placeholder="Статистика" name="walberisToken2" />
                        <label htmlFor="">Реклама</label>
                        <Input placeholder="Реклама" name="walberisToken3" />
                      </AccordionPanel>
                    </AccordionItem>

                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box as="span" flex="1" textAlign="left">
                            Ozon API
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        <label htmlFor="">Администратор</label>
                        <Input placeholder="Администратор" name="ozonToken1" />
                        <label htmlFor="">Товары</label>
                        <Input placeholder="Товары" name="ozonToken2" />
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                  {/* ============================================================================================================== */}
                </div>
                
              </div>

              <div className="formchildCont1">
                <label htmlFor="">Расчётный счёт</label>
                <Input
                  placeholder="Расчётный счёт"
                  name="Checkingaccount"
                  defaultValue={data.Checkingaccount}
                  key={data.Checkingaccount + "5"}
                />

                <label htmlFor="">БИК</label>
                <Input
                  placeholder="БИК"
                  name="btc"
                  defaultValue={data.btc}
                  key={data.btc + "6"}
                />
                <label htmlFor="">ОГРН (ОГРНИП)</label>
                <Input
                  placeholder="ОГРНИП"
                  name="ognip"
                  defaultValue={data.ognip}
                  key={data.ognip + "7"}
                />
                <BlockCompany data={data.isBlocedCompany} key={index} currentPage={currentPage}/>
                <div className={"loadingbtn"}>
                {loading ? (
                  <Button
                    variant="primary"
                    disabled
                    style={{ backgroundColor: "#5E83E0" }}
                  >
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    загрузка...
                  </Button>
                ) : (
                  <Button
                    colorScheme="blue"
                    type="submit"
                    style={{ backgroundColor: "#5E80E4" }}
                    className="creatCompany"
                  >
                    Редактировать
                  </Button>
                )}
                </div>
              </div>
              
            </form>
            {/* <button>Редактировать данные продавца</button> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShows(false)}>
            Закрывать
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
